import React, { useEffect, useState } from "react";
import axios from "axios";

const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API = `${ENV_API_BASE_URL}/api/blog-details`;

const CATEGORY_OPTIONS = [
  "Kundalini Yoga",
  "Yoga Online",
  "Yoga Philosophy",
  "Yoga Retreat",
  "Yoga Training",
];

const STEP_FIELDS = [
  { index: 1, tipParagraphKey: "step1Tip1Paragraph" },
  { index: 2, tipParagraphKey: "stepTip2Paragraph" },
  { index: 3, tipParagraphKey: "step1Tip3Paragraph" },
  { index: 4, tipParagraphKey: "step1Tip4Paragraph" },
  { index: 5, tipParagraphKey: "step1Tip5Paragraph" },
];

const BENEFIT_FIELDS = [1, 2, 3, 4, 5];
const WHO_FIELDS = [1, 2, 3, 4];
const DAILY_FIELDS = [1, 2, 3, 4];
const FAQ_FIELDS = [1, 2, 3, 4];

const EMPTY_FORM = {
  category: "",
  heroTitle: "",
  slug: "",
  heroSubtitle: "",
  breadcrumb: "",
  heroImage: "",
  BlogMainImage: "",
  introQuote: "",
  introText: "",
  whatHeading: "",
  whatParagraph: "",
  whatTitle: "",
  whatDescription: "",
  stepHeading: "",
  stepparagraph: "",
  step1Title: "",
  step1Desc: "",
  stepTip1Heading: "",
  step1Tip1Paragraph: "",
  step2Title: "",
  step2Desc: "",
  stepTip2Heading: "",
  stepTip2Paragraph: "",
  step3Title: "",
  step3Desc: "",
  stepTip3Heading: "",
  step1Tip3Paragraph: "",
  step4Title: "",
  step4Desc: "",
  stepTip4Heading: "",
  step1Tip4Paragraph: "",
  step5Title: "",
  step5Desc: "",
  stepTip5Heading: "",
  step1Tip5Paragraph: "",
  benefitHeading: "",
  benefitparagraph: "",
  benefit1Title: "",
  benefit1Desc: "",
  benefit1Icon: "",
  benefit2Title: "",
  benefit2Desc: "",
  benefit2Icon: "",
  benefit3Title: "",
  benefit3Desc: "",
  benefit3Icon: "",
  benefit4Title: "",
  benefit4Desc: "",
  benefit4Icon: "",
  benefit5Title: "",
  benefit5Desc: "",
  benefit5Icon: "",
  whyTitle: "",
  whyDescription: "",
  whoTitle: "",
  who1Title: "",
  who1Des: "",
  who2Title: "",
  who2Des: "",
  who3Title: "",
  who3Des: "",
  who4Title: "",
  who4Des: "",
  dailyMainTitle: "",
  daily1Title: "",
  daily1Desc: "",
  daily2Title: "",
  daily2Desc: "",
  daily3Title: "",
  daily3Desc: "",
  daily4Title: "",
  daily4Desc: "",
  precautionsTitle: "",
  precautionsText: "",
  chooseMainTitle: "",
  chooseTitle: "",
  choose1: "",
  choose2: "",
  choose3: "",
  choose4: "",
  choose5: "",
  choose6: "",
  conclusionMainTitle: "",
  conclusion: "",
  faq1Q: "",
  faq1A: "",
  faq2Q: "",
  faq2A: "",
  faq3Q: "",
  faq3A: "",
  faq4Q: "",
  faq4A: "",
};

const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const resolveImageSrc = (value) => {
  if (!value || typeof value !== "string") return "";
  if (/^https?:\/\//.test(value)) return value;
  if (value.startsWith("/uploads/")) return `${ENV_API_BASE_URL}${value}`;
  return `${ENV_API_BASE_URL}/uploads/${value}`;
};

function BlogDetailsAdmin() {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [tableData, setTableData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [imagePreviews, setImagePreviews] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(API);
      setTableData(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      console.error(err);
      setTableData([]);
    }
  };

  const resetForm = () => {
    setFormData(EMPTY_FORM);
    setEditId(null);
    setShowForm(false);
    setImagePreviews({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const next = {
        ...prev,
        [name]: value,
      };

      if (name === "heroTitle" && !editId) {
        next.slug = slugify(value);
      }

      if (name === "slug") {
        next.slug = slugify(value);
      }

      return next;
    });
  };

  const handleFileChange = (field, e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setFormData((prev) => ({
      ...prev,
      [field]: file,
    }));
    setImagePreviews((prev) => ({
      ...prev,
      [field]: previewUrl,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const data = new FormData();
      const payload = {
        ...formData,
        slug: slugify(formData.slug || formData.heroTitle),
      };

      Object.keys(payload).forEach((key) => {
        if (key === "_id" || key === "__v" || key === "createdAt" || key === "updatedAt") {
          return;
        }

        const value = payload[key];
        if (value instanceof File) {
          data.append(key, value);
        } else if (value !== undefined && value !== null) {
          data.append(key, value);
        }
      });

      if (editId) {
        await axios.put(`${API}/${editId}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await axios.post(API, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      await fetchData();
      resetForm();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to save blog post");
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (item) => {
    setFormData({
      ...EMPTY_FORM,
      ...item,
    });
    setEditId(item._id);
    setShowForm(true);
    setImagePreviews({});
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;

    try {
      await axios.delete(`${API}/${id}`);
      await fetchData();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to delete blog post");
    }
  };

  const getImagePreview = (field) => imagePreviews[field] || resolveImageSrc(formData[field]);

  return (
    <div className="container mt-5 pt-5">
      {!showForm && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Blog Posts</h4>
            <button
              className="btn btn-primary"
              onClick={() => {
                setFormData(EMPTY_FORM);
                setEditId(null);
                setShowForm(true);
                setImagePreviews({});
              }}
            >
              Create Blog Post
            </button>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Slug</th>
                  <th>Main Image</th>
                  <th>Hero Title</th>
                  <th>Category</th>
                  <th>Updated</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">No blog posts found</td>
                  </tr>
                ) : (
                  tableData.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.slug}</td>
                      <td>
                        {item.BlogMainImage ? (
                          <img
                            src={resolveImageSrc(item.BlogMainImage)}
                            width="80"
                            alt={item.heroTitle}
                            className="rounded"
                          />
                        ) : (
                          <span className="text-muted">No image</span>
                        )}
                      </td>
                      <td>{item.heroTitle}</td>
                      <td>{item.category}</td>
                      <td>{item.updatedAt ? new Date(item.updatedAt).toLocaleDateString() : "-"}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => handleEdit(item)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(item._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="card p-4 shadow">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0">{editId ? "Edit Blog Post" : "Create Blog Post"}</h4>
            <button type="button" className="btn btn-secondary" onClick={resetForm}>
              Back to List
            </button>
          </div>

          <h5 className="border-bottom pb-2">Hero Section</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Category</label>
              <select className="form-control" name="category" value={formData.category} onChange={handleChange}>
                <option value="">Select</option>
                {CATEGORY_OPTIONS.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Slug</label>
              <input className="form-control" name="slug" value={formData.slug} onChange={handleChange} />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Hero Title</label>
              <input className="form-control" name="heroTitle" value={formData.heroTitle} onChange={handleChange} />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Hero Subtitle</label>
              <input className="form-control" name="heroSubtitle" value={formData.heroSubtitle} onChange={handleChange} />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Breadcrumb</label>
              <input className="form-control" name="breadcrumb" value={formData.breadcrumb} onChange={handleChange} />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Hero Image</label>
              <input type="file" className="form-control" accept="image/*" onChange={(e) => handleFileChange("heroImage", e)} />
              {getImagePreview("heroImage") && (
                <img src={getImagePreview("heroImage")} alt="Hero" className="mt-2 rounded" style={{ maxHeight: "100px" }} />
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Blog Main Image</label>
              <input type="file" className="form-control" accept="image/*" onChange={(e) => handleFileChange("BlogMainImage", e)} />
              {getImagePreview("BlogMainImage") && (
                <img src={getImagePreview("BlogMainImage")} alt="Main" className="mt-2 rounded" style={{ maxHeight: "100px" }} />
              )}
            </div>
          </div>

          <h5 className="border-bottom pb-2 mt-4">Intro Section</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Intro Quote</label>
              <textarea className="form-control" name="introQuote" value={formData.introQuote} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Intro Text</label>
              <textarea className="form-control" name="introText" value={formData.introText} onChange={handleChange} />
            </div>
          </div>

          <h5 className="border-bottom pb-2 mt-4">What Is Section</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Heading</label>
              <input className="form-control" name="whatHeading" value={formData.whatHeading} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Paragraph</label>
              <textarea className="form-control" name="whatParagraph" value={formData.whatParagraph} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Title</label>
              <input className="form-control" name="whatTitle" value={formData.whatTitle} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Description</label>
              <textarea className="form-control" name="whatDescription" value={formData.whatDescription} onChange={handleChange} />
            </div>
          </div>

          <h5 className="border-bottom pb-2 mt-4">Steps Section</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Step Heading</label>
              <input className="form-control" name="stepHeading" value={formData.stepHeading} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Step Paragraph</label>
              <textarea className="form-control" name="stepparagraph" value={formData.stepparagraph} onChange={handleChange} />
            </div>
          </div>

          {STEP_FIELDS.map(({ index, tipParagraphKey }) => (
            <div key={index} className="card p-3 mb-3">
              <h6>Step {index}</h6>
              <input
                className="form-control mb-2"
                placeholder="Title"
                name={`step${index}Title`}
                value={formData[`step${index}Title`]}
                onChange={handleChange}
              />
              <textarea
                className="form-control mb-2"
                placeholder="Description"
                name={`step${index}Desc`}
                value={formData[`step${index}Desc`]}
                onChange={handleChange}
              />
              <input
                className="form-control mb-2"
                placeholder="Tip Heading"
                name={`stepTip${index}Heading`}
                value={formData[`stepTip${index}Heading`]}
                onChange={handleChange}
              />
              <textarea
                className="form-control"
                placeholder="Tip Paragraph"
                name={tipParagraphKey}
                value={formData[tipParagraphKey]}
                onChange={handleChange}
              />
            </div>
          ))}

          <h5 className="border-bottom pb-2 mt-4">Benefits</h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Heading</label>
              <input className="form-control" name="benefitHeading" value={formData.benefitHeading} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Paragraph</label>
              <textarea className="form-control" name="benefitparagraph" value={formData.benefitparagraph} onChange={handleChange} />
            </div>
          </div>

          {BENEFIT_FIELDS.map((index) => (
            <div key={index} className="card p-3 mb-3">
              <h6>Benefit {index}</h6>
              <input
                className="form-control mb-2"
                placeholder="Title"
                name={`benefit${index}Title`}
                value={formData[`benefit${index}Title`]}
                onChange={handleChange}
              />
              <textarea
                className="form-control mb-2"
                placeholder="Description"
                name={`benefit${index}Desc`}
                value={formData[`benefit${index}Desc`]}
                onChange={handleChange}
              />
              <input
                className="form-control"
                placeholder="Icon"
                name={`benefit${index}Icon`}
                value={formData[`benefit${index}Icon`]}
                onChange={handleChange}
              />
            </div>
          ))}

          <h5 className="border-bottom pb-2 mt-4">Why Practice</h5>
          <input className="form-control mb-2" placeholder="Title" name="whyTitle" value={formData.whyTitle} onChange={handleChange} />
          <textarea className="form-control mb-3" placeholder="Description" name="whyDescription" value={formData.whyDescription} onChange={handleChange} />

          <h5 className="border-bottom pb-2 mt-4">Who Should Practice</h5>
          <input className="form-control mb-3" placeholder="Section Title" name="whoTitle" value={formData.whoTitle} onChange={handleChange} />
          {WHO_FIELDS.map((index) => (
            <div key={index} className="row mb-3">
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder={`Audience ${index} Title`}
                  name={`who${index}Title`}
                  value={formData[`who${index}Title`]}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-8">
                <textarea
                  className="form-control"
                  placeholder={`Audience ${index} Description`}
                  name={`who${index}Des`}
                  value={formData[`who${index}Des`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          ))}

          <h5 className="border-bottom pb-2 mt-4">Daily Integration</h5>
          <input className="form-control mb-3" placeholder="Section Title" name="dailyMainTitle" value={formData.dailyMainTitle} onChange={handleChange} />
          {DAILY_FIELDS.map((index) => (
            <div key={index} className="row mb-3">
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder={`Daily ${index} Title`}
                  name={`daily${index}Title`}
                  value={formData[`daily${index}Title`]}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-8">
                <textarea
                  className="form-control"
                  placeholder={`Daily ${index} Description`}
                  name={`daily${index}Desc`}
                  value={formData[`daily${index}Desc`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          ))}

          <h5 className="border-bottom pb-2 mt-4">Precautions</h5>
          <input className="form-control mb-2" name="precautionsTitle" placeholder="Title" value={formData.precautionsTitle} onChange={handleChange} />
          <textarea className="form-control mb-3" name="precautionsText" placeholder="Text" value={formData.precautionsText} onChange={handleChange} />

          <h5 className="border-bottom pb-2 mt-4">Why Choose Section</h5>
          <input className="form-control mb-2" name="chooseMainTitle" placeholder="Main Title" value={formData.chooseMainTitle} onChange={handleChange} />
          <textarea className="form-control mb-3" name="chooseTitle" placeholder="Intro Paragraph" value={formData.chooseTitle} onChange={handleChange} />
          {[1, 2, 3, 4, 5, 6].map((index) => (
            <input
              key={index}
              className="form-control mb-2"
              name={`choose${index}`}
              placeholder={`Feature ${index}`}
              value={formData[`choose${index}`]}
              onChange={handleChange}
            />
          ))}

          <h5 className="border-bottom pb-2 mt-4">Conclusion</h5>
          <input className="form-control mb-2" name="conclusionMainTitle" placeholder="Title" value={formData.conclusionMainTitle} onChange={handleChange} />
          <textarea className="form-control mb-3" name="conclusion" placeholder="Conclusion Text" value={formData.conclusion} onChange={handleChange} />

          <h5 className="border-bottom pb-2 mt-4">FAQ</h5>
          {FAQ_FIELDS.map((index) => (
            <div key={index} className="row mb-3">
              <div className="col-md-6">
                <input
                  className="form-control"
                  placeholder={`Question ${index}`}
                  name={`faq${index}Q`}
                  value={formData[`faq${index}Q`]}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <textarea
                  className="form-control"
                  placeholder={`Answer ${index}`}
                  name={`faq${index}A`}
                  value={formData[`faq${index}A`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          ))}

          <div className="mt-4 d-flex gap-2">
            <button className="btn btn-success" disabled={saving}>
              {saving ? "Saving..." : "Save Blog Post"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={resetForm} disabled={saving}>
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default BlogDetailsAdmin;
